import { get, post } from 'axios'

const host = process.env.VUE_APP_CCAPI

function save({token_auth, rfc, email, cellphone, date_of_admission, 
  interbank_clabe, bank_name, amount, beneficiary_name, beneficiary_middle_name, 
  beneficiary_maternal_name, beneficiary_paternal_name,
  amount_without_interest, interest, 
  percentage, type_of_retirement, document_list}) {
  const resource = `/fas/retirement_request/create`
  const API_URL = `${host}${resource}`

  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth,
    rfc: rfc,
    email: email,
    cellphone: cellphone,
    date_of_admission: date_of_admission,
    interbank_clabe: interbank_clabe,
    bank_name: bank_name,
    amount: amount,
    beneficiary_name: beneficiary_name,
    beneficiary_middle_name: beneficiary_middle_name,
    beneficiary_maternal_name: beneficiary_maternal_name,
    beneficiary_paternal_name: beneficiary_paternal_name,
    amount_without_interest: amount_without_interest,
    interest: interest,
    percentage: percentage,
    type_of_retirement: type_of_retirement,
    document_list: document_list
  }

  return post(API_URL, params, config)
}

function cancel(token_auth, id) {
  const resource = `/fas/retirement_request/cancel`
  const API_URL = `${host}${resource}`

  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth,
    id: id
  }

  return post(API_URL, params, config)
}

function accept(token_auth, id) {
  const resource = `/fas/retirement_request/accept`
  const API_URL = `${host}${resource}`

  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth,
    id: id
  }

  return post(API_URL, params, config)
}

function reject(token_auth, id) {
  const resource = `/fas/retirement_request/rejected`
  const API_URL = `${host}${resource}`

  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth,
    id: id
  }

  return post(API_URL, params, config)
}

function getTotalRetirement (token_auth, rfc, admissionDate) {    
  const resource = `/fas/retirement_request/calculate`
  const API_URL = `${host}${resource}`
  
  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth,
    rfc: rfc,
    date_of_admission: admissionDate
  }
  
  return get(API_URL, { params, config })
}

function getTotalRetirementByDeath (token_auth, rfc, admissionDate) {    
  const resource = `/fas/retirement_request/calculate_by_death`
  const API_URL = `${host}${resource}`
  
  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth,
    rfc: rfc,
    date_of_admission: admissionDate
  }
  
  return get(API_URL, { params, config })
}

function getByRfc (token_auth, rfc) {    
  const resource = `/fas/retirement_request/get_by_rfc`
  const API_URL = `${host}${resource}`
  
  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth,
    rfc: rfc
  }
  
  return get(API_URL, { params, config })
}

function getByStatus (token_auth, status) {    
  const resource = `/fas/retirement_request/get_by_status`
  const API_URL = `${host}${resource}`
  
  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth,
    status: status
  }
  
  return get(API_URL, { params, config })
}

function getAll (token_auth, process_name) {    
  const resource = `/fas/retirement_request/get_all`
  const API_URL = `${host}${resource}`
  
  const config = {
    headers: {
      "Content-Type": "application/json",
    }
  };

  const params = {
    token_auth: token_auth,
    process_name: process_name
  }
  
  return get(API_URL, { params, config })
}

export {
  save,
  cancel,
  accept,
  reject,
  getTotalRetirement,
  getTotalRetirementByDeath,
  getByRfc,
  getByStatus,
  getAll
}